import { COLORS } from 'helpers/globals'

export default {
  filterContainer: {
    display: 'flex',
    padding: '0 1rem',
    alignItems: 'center',
    minHeight: '5rem',
    margin: '.5rem 0'
  },
  formFactors: {
    display: 'flex',
    flex: 1,
    fontSize: '1rem'
  },
  formFactor: {
    flex: 1,
    textAlign: 'center',
    padding: '.5rem 0',
    color: 'white',
    minHeight: '5rem',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    borderTop: '1px solid #2972B1',
    borderBottom: '1px solid #2972B1',
    '&:first-of-type': {
      borderRadius: '.75rem 0 0 .75rem',
      borderLeft: '1px solid #2972B1'
    },
    '&:last-of-type': {
      borderRadius: '0 .75rem .75rem 0',
      borderRight: '1px solid #2972B1'
    },
    '&:not(:last-of-type)': { borderRight: '1px solid #2972B1' },
    color: 'white',
    backgroundColor: 'rgba(66, 139, 202, 0.55)',
    '&:hover:not(.selected)': {
      backgroundColor: 'rgba(66, 139, 202, 0.70)'
    },
    '&.selected': {
      backgroundColor: 'rgba(66, 139, 202, 0.85)',
      '&:hover': { background: COLORS.primary }
    }
  },
  image: {
    maxHeight: '2rem',
    maxWidth: '90%',
    margin: 'auto'
  },
  searchButton: {
    margin: 'auto',
    marginLeft: '.5rem',
    fontSize: '2.5rem'
  },
  searchWrapper: {
    flex: 1
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/Filter/style.js